module.exports = "../dist/img/423x544_10.3eb1.jpg";